import {API} from "../../backend";

export const getUser = (userId, token) => {
    return fetch(`${API}/get-user/${userId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }

  export const getUserFromDbAdmin=(userId)=>{
    return fetch(`${API}/get-user-db909-admin-6a676fg/${userId}`,{
      method: "GET",
      headers:{
        Accept: "application/json"
    },
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }

  export const validateOtpSavePassword=(body)=>{
    return fetch(`${API}/validate-otp-save-password`,{
      method: "POST",
      headers:{
        Accept: "application/json",
        'Content-Type':'application/json'
      },
      body:JSON.stringify(body)
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }


  export const validateOtpLogin=(body)=>{
    return fetch(`${API}/validate-otp-user-login`,{
      method: "POST",
      headers:{
        Accept: "application/json",
        'Content-Type':'application/json'
      },
      body:JSON.stringify(body)
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }

export const authenticateSession = (userId,token) =>{
  return fetch(`${API}/authenticate-session`,{
    method: "POST",
    headers:{
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body:JSON.stringify({token,userId})
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

